<template>
  <div class="wrap">
    <div class="loading-box" v-if="isLoad">
      <div class="loading">
        <div><i class="fad fa-spinner"></i></div>
        <span>Loading...</span>
      </div>
    </div>
    <h2>
      <img src="@/assets/img/logo2.svg" alt="愛薇樂嚴選內衣 - 計件系統" />
      愛薇樂嚴選內衣 - 計件系統
    </h2>
    <div class="list-area">
      <div class="tit-box">
        <h3>貨號單列表</h3>
      </div>
      <ul class="list list2 list-tit order-list">
        <li class="title">
          <div>貨號單名稱</div>
          <div>尺寸</div>
          <div>顏色</div>
          <!-- <div>日期</div> -->
        </li>
      </ul>
      <ul class="list list2 order-list">
        <OrderListItem
          v-for="(item, index) in list"
          :key="index"
          :id="item.order_id"
          :orderId="item.order_name"
          :size="item.order_size"
          :color="item.color"
        />
      </ul>
    </div>
  </div>
</template>
<script>
import OrderListItem from "@/components/OrderListItem.vue";

import { apiRecordList } from "@/api/api.js";

export default {
  data() {
    return {
      isLoad: true,
      list: [
        {
          order_id: "-", //id
          order_name: "-", //orderId
          order_size: "-", //size
          color: "-",
          created_at: "-", //date
        },
      ],
    };
  },
  mounted() {
    //=== 取得貨號單列表 ===
    apiRecordList()
      .then((result) => {
        console.log(result.data);
        if (result.data.message == "Success") {
          //== 放入項目 ==
          this.list = result.data.data;
          this.isLoad = false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  components: {
    OrderListItem,
  },
};
</script>